import { useField } from '@unform/core'
import { useEffect, useRef } from 'react'
import {
  GInputContent,
  InputLoadingIcon,
  InputMaskContent,
  SpanContent,
} from './styles'

export default function GInput({
  name,
  mask = null,
  loading = false,
  ...rest
}) {
  const inputRef = useRef(null)
  let field

  /** Caso em que ainda não está sendo usado com unform */
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    field = useField(name)
  } catch {
    return <input name={name} {...rest} />
  }

  const { fieldName, defaultValue, registerField, error, clearError } = field

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      getValue: (ref) => {
        if (ref.type === 'checkbox') {
          return ref.checked
        }

        if (ref.type === 'radio') {
          const checked = ref.find((ref) => ref.checked)

          return checked ? checked.value : null
        }
        return ref.value
      },
    })
  }, [fieldName, registerField])

  const inputProps = {
    defaultValue: defaultValue,
    hasError: !!error,
    name: name,
    onFocus: clearError,
    ref: inputRef,
    ...rest,
  }

  return (
    <>
      {mask ? (
        <InputMaskContent mask={mask} {...inputProps} />
      ) : (
        <GInputContent {...inputProps} />
      )}
      {!!error && <SpanContent hasError={!!error}>{error}</SpanContent>}
      {loading ? (
        <InputLoadingIcon>
          <i />
        </InputLoadingIcon>
      ) : null}
    </>
  )
}
